import messageService from './message.service';
import globalStateService from './globalState.service';

export { globalStateService, messageService };



// WEBPACK FOOTER //
// src/dialpad/service/index.js